import { create } from "zustand";
import { persist } from "zustand/middleware";

interface LocationStore {
  timezone: string;
  setTimezone: (newTz: string) => void;
}

export const useLocationStore = create<LocationStore>()(
  persist(
    (set) => ({
      timezone: "",
      setTimezone: (newTz) => set({ timezone: newTz }),
    }),
    { name: "location-store" },
  ),
);
